var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-opacity-30 bg-gray-100 absolute w-full h-full left-0 top-0 z-30",class:!_vm.emptyConfig && 'opacity-0 pointer-events-none'})
}
var staticRenderFns = []

export { render, staticRenderFns }